import stringSanitizer from "stringSanitizer";

function formatLocationSearchData(value, regionList = []) {
  let searchFilters = {
    postcode: null,
    region: null,
    city: null,
  };

  if (value) {
    const postcodeRegex = new RegExp(process.env.REACT_APP_POSTCODE_REGEX);
    if (postcodeRegex.test(value)) {
      searchFilters.postcode = value;
      searchFilters.region = null;
      searchFilters.city = null;
    }
    else {
      searchFilters.postcode = null;

      let locationData = value.split(',');
      if (locationData.length > 1) {
        const city = locationData.splice(0, 1);
        searchFilters.region = stringSanitizer(locationData.join('').trim().toLowerCase());
        searchFilters.city = stringSanitizer(city[0].trim().toLowerCase());
      }
      else if (locationData.length === 1) {
        const value = stringSanitizer(locationData[0].trim().toLowerCase());
        if (regionList && regionList.length && regionList.includes(value)) {
          searchFilters.region = value;
          searchFilters.city = null;
        }
        else {
          searchFilters.region = null;
          searchFilters.city = value;
        }
      }
    }
  }

  return searchFilters;
}

export default formatLocationSearchData;
